export default __webpack_public_path__ + "static/media/social-media-example.adcf4ec9.jpg";